import type { CommonResponse } from '../types/responseModal';
import { Request } from '../utils/request';

export interface PersonaInfo {
  id: string;
  display_name: string;
  description?: string;
  email?: string;
  avatar_data?: string | null;
  lora_model_id: string;
  is_builtin?: boolean;
  doc_count: number;
  lora_registered: boolean;
}

export interface PersonaListRes {
  personas: PersonaInfo[];
  default_persona_id: string;
}

export const listPersonas = () => {
  return Request<CommonResponse<PersonaListRes>>({
    method: 'get',
    url: '/api/personas'
  });
};

export const getCurrentPersona = () => {
  return Request<CommonResponse<{ persona_id: string; persona: PersonaInfo }>>({
    method: 'get',
    url: '/api/personas/current'
  });
};

export const getPersona = (personaId: string) => {
  return Request<CommonResponse<PersonaInfo>>({
    method: 'get',
    url: `/api/personas/${personaId}`
  });
};

export interface UpdatePersonaPayload {
  display_name?: string;
  description?: string;
  email?: string;
}

export const updatePersona = (personaId: string, data: UpdatePersonaPayload) => {
  return Request<CommonResponse<PersonaInfo>>({
    method: 'put',
    url: `/api/personas/${personaId}`,
    data
  });
};
